import { useLocalStorageState } from 'ahooks';
import { useEffect } from 'react';

interface ToggleFreeState {
  active: boolean;
  exit: () => void;
  enter: () => void;
}

interface ToggleFreeProps {
  active: boolean;
  localStorageKey: string;
  onToggle: (value: boolean) => void;
}

export const useToggleFreeMode = ({
  active,
  localStorageKey,
  onToggle,
}: ToggleFreeProps): ToggleFreeState => {
  const [, saveToLocalStorage] = useLocalStorageState<boolean>(localStorageKey);

  useEffect(() => {
    saveToLocalStorage(active);
  }, [active, saveToLocalStorage]);

  const exit = () => {
    onToggle(false);
  };
  const enter = () => {
    onToggle(true);
  };

  return {
    active,
    exit,
    enter,
  };
};
